/* eslint-disable */
import r1 from './r1.js'
import o from './o.js'
import c11 from './c11.js'
import s from './s.js'
import l from './l.js'
import u from './runu.js'
import r from './rr.js'
// var r = function e(t, n, i) {
//   null === t && (t = Function.prototype);
//   var r = Object.getOwnPropertyDescriptor(t, n);
//   if (void 0 === r) {
//     var o = Object.getPrototypeOf(t);
//     return null === o ? void 0 : e(o, n, i)
//   }
//   if ("value" in r)
//     return r.value;
//   var a = r.get;
//   return void 0 !== a ? a.call(i) : void 0
// }

var d = function (e) {
  function a(e, t) {
    var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, a);
    var i = window.goodGPU ? .2 : .4
      , r = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (a.__proto__ || Object.getPrototypeOf(a)).call(this, e, t, (0,
        c11.merge)({
          ratio: i
        }, n)));
    r.render = r.render.bind(r),
      r.resize = r.resize.bind(r);
    var o = {
      width: window.innerWidth,
      height: window.innerHeight,
      renderer: {
        antialias: !0,
        alpha: !0,
        bgColor: 16777215,
        shadow: !1,
        pixelRatio: Math.min(window.devicePixelRatio, window.goodGPU ? 1.5 : 1.2)
      },
      camera: {
        type: "OrthographicCamera",
        fov: 45,
        near: 1,
        far: 1e3
      },
      wagner: !1,
      orbits: !1,
      verbose: !1,
      canvas: t,
      ratio: i
    };
    return r.options = (0,
      c11.merge)(o, n),
      r.app = new s.default(r.options),
      r.app.camera.position.z = 1,
      l.default.bind(r.id, r.resize),
      r.app.render(),
      r
  }
  return function (e, t) {
    l.default.start()

    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(a, o.default),
    r1(a, [{
      key: "display",
      value: function () {
        r(a.prototype.__proto__ || Object.getPrototypeOf(a.prototype), "display", this).call(this),
          u.default.bind(this.id, this.render)
      }
    }, {
      key: "hide",
      value: function () {
        r(a.prototype.__proto__ || Object.getPrototypeOf(a.prototype), "hide", this).call(this),
          u.default.unbind(this.id)
      }
    }, {
      key: "render",
      value: function () {
        this.app.render()
      }
    }, {
      key: "resize",
      value: function () {
        this.locate(),
          this.app.resize(this.view.width, this.view.height)
      }
    }, {
      key: "dispose",
      value: function () {
        l.default.unbind(this.id),
          u.default.unbind(this.id),
          this.render = this.resize = null,
          r(a.prototype.__proto__ || Object.getPrototypeOf(a.prototype), "dispose", this).call(this)
      }
    }]),
    a
}();

var t = { default: d }
export default t
